"use strict";
/**
 * SCORM 1.2 and SCORM 2004 CMI Runtime Data Model Interfaces.
 * Used by ScormPlayer client bridge and server tracking endpoint.
 */
Object.defineProperty(exports, "__esModule", { value: true });
